// Registro de reportes disponibles en el 360 v2.
// Cada reporte define su metadata y su componente de contenido.
// Para agregar un nuevo reporte, basta con añadir una entrada aquí.

import { Scale, BarChart3, Droplets, TrendingUp, Package, Shirt, PackageCheck, CalendarDays, CalendarRange, Wallet, LineChart } from 'lucide-react';

const reports = [
  {
    id: 'lotes-vs-ciclos',
    label: 'Conciliación de Lotes vs. Ciclos',
    description: 'Cruce entre lotes registrados manualmente y los ciclos leídos del control de las lavadoras.',
    icon: Scale,
    color: 'amber',
    enabled: true,
  },
  // Próximos reportes (placeholder — los habilitamos cuando estén listos)
  {
    id: 'costos-utilidad',
    label: 'Costos y Utilidad',
    description: 'Análisis de margen, costo por kg y comparativos con periodos anteriores.',
    icon: TrendingUp,
    color: 'emerald',
    enabled: false,
  },
  {
    id: 'consumo-productos',
    label: 'Detergentes y Químicos',
    description: 'Consumo real de inventario contra la dosificación teórica de los programas.',
    icon: Droplets,
    color: 'sky',
    enabled: true,
  },
  {
    id: 'recepcion-ropa-sucia',
    label: 'Recepción de ropa sucia',
    description: 'Registros de lotes de ropa sucia recibidos en el periodo, exportables a Excel.',
    icon: Shirt,
    color: 'slate',
    enabled: true,
  },
  {
    id: 'control-diario-produccion',
    label: 'Control diario de producción',
    description: 'Registro diario del mes: ciclos, lotes, alistamiento y horas, con productividad y conciliación de facturación (formato del Excel del cliente).',
    icon: CalendarDays,
    color: 'navy',
    enabled: true,
    monthly: true,
  },
  {
    id: 'consolidado-anual-produccion',
    label: 'Consolidado anual de producción',
    description: 'Genera, recalcula y compara los consolidados mensuales del control diario (como la hoja RESUMEN ANUAL del Excel).',
    icon: CalendarRange,
    color: 'navy',
    enabled: true,
    yearly: true,
  },
  {
    id: 'analisis-nomina',
    label: 'Análisis de nómina (todas las plantas)',
    description: 'Evolución del costo de las nóminas generadas, comparado con los kilos recibidos, y participación de cada planta en costo y kilos.',
    icon: LineChart,
    color: 'emerald',
    enabled: true,
    // No se filtra por centro: abarca todas las plantas de las nóminas.
    global: true,
  },
  {
    id: 'nomina-centro',
    label: 'Nómina del centro',
    description: 'Costo de nómina del centro en el rango: básico, auxilio, recargos y extras por quincena y por persona (mismo cálculo de Nóminas por periodo).',
    icon: Wallet,
    color: 'emerald',
    enabled: true,
  },
  {
    id: 'alistamientos-registros',
    label: 'Alistamientos',
    description: 'Registros de alistamientos creados en el periodo, exportables a Excel.',
    icon: PackageCheck,
    color: 'violet',
    enabled: true,
  },
  {
    id: 'alistamiento',
    label: 'Alistamiento por Turno',
    description: 'Comparativo de alistamiento (ropa lista) por turno y operario.',
    icon: Package,
    color: 'violet',
    enabled: false,
  },
];

// Devuelve el reporte por id, o el primero habilitado por defecto
export const getReportById = (id) => reports.find((r) => r.id === id) || reports.find((r) => r.enabled) || reports[0];

export const getEnabledReports = () => reports.filter((r) => r.enabled);

export default reports;
